var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DrawerAccordion",
    { attrs: { id: "contact", title: _vm.$t.__(_vm.titleLabel) } },
    [
      _c(
        "template",
        { slot: "action" },
        [
          _vm.showEditButton && !_vm.isEmpty
            ? _c("CompassPlainButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.edit"),
                  size: "small"
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.handleEdit($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overview-contact-block" },
        [
          _c("div", { staticClass: "overview-contact-block__content" }, [
            _vm.isEmpty
              ? _c(
                  "div",
                  { staticClass: "overview-contact-block__empty" },
                  [
                    _c("CompassObject", {
                      attrs: { size: "small", object: "contact" }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "overview-contact-block__empty-description typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t.__(_vm.emptyDescription)) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "overview.contactBlock.empty.disabledTooltip"
                          ),
                          disabled: !_vm.disableButton
                        }
                      },
                      [
                        _c("CompassButton", {
                          staticClass: "overview-contact-block__empty-button",
                          attrs: {
                            type: "secondary",
                            size: "small",
                            label: _vm.$t.__(_vm.emptyButton),
                            disabled: _vm.disableButton
                          },
                          on: { click: _vm.handleCreateContact }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "overview-contact-block__content-header" },
                      [
                        _c(
                          "CompassTooltip",
                          {
                            attrs: {
                              content: _vm.$t.__("common.actions.see_the_file"),
                              arrow: false,
                              placement: "right-start"
                            }
                          },
                          [
                            _c(
                              "RouterLink",
                              { attrs: { to: _vm.contact.link } },
                              [
                                _c("CompassObject", {
                                  attrs: {
                                    label: _vm.contact.fullName,
                                    caption: _vm.contact.position,
                                    size: "small",
                                    object: "contact",
                                    isLink: true
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "CompassDescriptionList",
                      { attrs: { variant: "frozen-field", size: "small" } },
                      [
                        _vm.contact.email
                          ? _c(
                              "CompassDescriptionListItem",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.email")
                                }
                              },
                              [
                                _c(
                                  "EmailLinkCompass",
                                  {
                                    attrs: {
                                      email: _vm.contact.email,
                                      linkedid: _vm.linkedid,
                                      linkedtype: _vm.linkedtype
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.contact.email) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contact.phone
                          ? _c(
                              "CompassDescriptionListItem",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.phone")
                                }
                              },
                              [
                                _c("PhoneLinkCompass", {
                                  attrs: { phoneNumber: _vm.contact.phone }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contact.mobile
                          ? _c(
                              "CompassDescriptionListItem",
                              {
                                attrs: {
                                  label: _vm.$t.__("common.labels.mobile")
                                }
                              },
                              [
                                _c("PhoneLinkCompass", {
                                  attrs: { phoneNumber: _vm.contact.mobile }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
          ]),
          _vm._v(" "),
          _vm.showAllContacts
            ? _c("CompassPlainButton", {
                staticClass: "overview-contact-block__all-contacts",
                attrs: { label: _vm.$t.__(_vm.allContactsLabel) },
                on: { click: _vm.navigate }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }